export var ICommerceInitialClickTrigger;
(function (ICommerceInitialClickTrigger) {
    ICommerceInitialClickTrigger["VIDEO"] = "video";
    ICommerceInitialClickTrigger["PRODUCT_CARD"] = "product_card";
    ICommerceInitialClickTrigger["INSTREAM_PDP_EXTERNAL_LINK"] = "instream_pdp_external_link";
    ICommerceInitialClickTrigger["INSTREAM_PDP_SHOP_NOW"] = "instream_pdp_shop_now";
    ICommerceInitialClickTrigger["LS_PREVIEW_PRODUCT_BUTTON"] = "ls_preview_product_button";
    ICommerceInitialClickTrigger["PRODUCT_HIGHLIGHT"] = "product_highlight";
    ICommerceInitialClickTrigger["PRODUCT_LIST_ITEM"] = "product_list_item";
})(ICommerceInitialClickTrigger || (ICommerceInitialClickTrigger = {}));
export var ICommerceClickTarget;
(function (ICommerceClickTarget) {
    ICommerceClickTarget["INSTREAM_PDP"] = "instream_pdp";
    ICommerceClickTarget["OUTSTREAM_PDP"] = "outstream_pdp";
})(ICommerceClickTarget || (ICommerceClickTarget = {}));
